<app-citizen-header></app-citizen-header>
<div class="p-2">
  <app-portal-title-bar [toHome]="true" [title]="'Huduma Zilizoombwa'"></app-portal-title-bar>
</div>
<div class="mt-3 w-full grid grid-cols-4 gap-4 px-3 mb-3">
  <div class="bg-primary-50 flex flex-col shadow-md p-3 rounded-md">
    <div class="flex items-center border-b p-2" style="border-color: rgb(15 33 103)">
      <mat-icon svgIcon="total_service"></mat-icon>
      <span class="!font-bold !text-sm !ml-2 !text-primary-600">Huduma Zilizoombwa</span>
    </div>
    <span class="!font-bold !text-3xl !text-primary-600">{{ servicesRequestSummary?.requests }}</span>
  </div>

  <div class="bg-green-50 flex flex-col shadow-md p-3 rounded-md">
    <div  class="flex items-center border-b p-2" style="border-color:  rgb(34 197 94)">
      <mat-icon svgIcon="approved_service"></mat-icon>
      <span class="!font-bold ml-2 !text-sm !text-green-600">Huduma Zilizotolewa</span>
    </div>
    <span class="!font-bold !text-3xl !text-green-600">{{ servicesRequestSummary?.delivered }}</span>
  </div>

  <div class="bg-amber-50 flex flex-col shadow-md p-3 rounded-md">
    <div class="flex items-center p-2 border-b" style="border-color:  rgb(255 196 54)">
      <mat-icon svgIcon="pending_service"></mat-icon>
      <span class="!font-bold ml-2 !text-sm !text-amber-600">Huduma Zinazosubiri</span>
    </div>
    <span class="!font-bold !text-3xl !text-amber-600">{{ servicesRequestSummary?.pending }}</span>
  </div>

  <div class="bg-red-50 flex flex-col shadow-md p-3 rounded-md">
    <div class="flex items-center p-2 border-b" style="border-color:  rgb(239 68 68)">
      <mat-icon svgIcon="rejected_service"></mat-icon>
      <span class="!font-bold ml-2 !text-sm !text-red-600">Huduma Zilizopitiliza Muda</span>
    </div>
    <span class="!font-bold !text-3xl !text-red-600">{{ servicesRequestSummary?.overdue }}</span>
  </div>
</div>
<div class="w-full flex justify-end px-2">
  <button class="add-button" mat-raised-button
          routerLink="/service-by-group/sector">
    <mat-icon>add</mat-icon>
    Omba Huduma
  </button>
</div>
<div class="mt-2 mx-2 move-left">
  <app-data-table-hybrid
                         [columnHeader]="tableColumns"
                         [hasActionsColumn]="true"
                         [isPageable]="true"
                         [searchFields]="[]"
                         [tableData]="formResponses$"
                         (pageable)="pageAble($event)"
  >
    <ng-template #actions let-data="data">
      <div>
        <span class="icon-holder cursor-pointer color-primary" matTooltip="Angalia Zaidi" matTooltipPosition="left"
              routerLink="/client-services/{{data?.uniqueId}}"
              matTooltipClass="primary-tooltip">
          <mat-icon svgIcon="view"></mat-icon>
        </span>
      </div>
    </ng-template>
  </app-data-table-hybrid>
</div>

